module.exports = __webpack_public_path__ + "static/media/StoryBackgroundImage.415fc708.png";